import qs from 'qs';

import { requiredParam } from 'sdc-utilities';

export default (function (_ref) {
  var _ref$backend = _ref.backend,
      backend = _ref$backend === undefined ? requiredParam('backend') : _ref$backend,
      _ref$typeID = _ref.typeID,
      typeID = _ref$typeID === undefined ? requiredParam('typeID') : _ref$typeID;

  var cmsContent = 'content/';
  var baseUrl = cmsContent + typeID;
  return {
    create: function create(entry) {
      return function () {
        return backend.post(baseUrl, entry || {});
      };
    },
    list: function list(params) {
      return function () {
        return backend.get(baseUrl + '?' + qs.stringify(params));
      };
    },
    update: function update(entry) {
      return function () {
        return backend.put('entries', entry);
      };
    },
    remove: function remove(entry) {
      return function () {
        return backend.delete(cmsContent + entry.id);
      };
    }
  };
});